import Badge from "./Badge";
import Modal from "./Modal";


function Cards(props) {
    const {post} = props;
    const {percentage} = calculation_info !== "null" ? JSON.parse(calculation_info) : {percentage: 0};
    const disclaimer = post.download_disclaimer === null ? '' : post.download_disclaimer;
    const cnc_cc = "cnc_cc"; // cc climated commited son para todos los items que no son 100%
    const cnc_cn = "cnc_cn";// cc carbon neutral full access
    let subscriber = assignSubscriber(percentage);
    let cssClass = '';
    switch (subscriber) {
        case "0" :
            cssClass ='restricted'; 
            break;
        case "1":
            if(!post.is_carbon_neutral){
                cssClass = cnc_cn; 
            }
           break;
        case "2" :
            if(post.is_carbon_neutral || !post.is_carbon_neutral){
                cssClass = cnc_cc; 
            }
           
           break;
    }
    
    function assignSubscriber(val){
        if(val >= 100){
            return "2"
        }else if( val<100 && val >= 50){
            return "1"
        }else{
            return "0"
        }
    }
    

    //console.log(post);
    return (

            <div className={`card border-0 grid-item ${ cssClass }`}>
            <Badge/>
            <div className="wpb_single_image">
                <a data-toggle="modal" className="vc_general"  href={`#id${post.id}`}>
                    <img className="card-img-top" src={post.img} alt={post.title} title={post.title}/>
                </a>
            </div>
            <div className="vc_custom_heading vc_gitem-post-data-source-post_title">
                <h4>
                    <a data-toggle="modal" href={`#id${post.id}`}>{post.title}</a>
                </h4>
            </div>
            <div className="vc_custom_heading vc_gitem-post-data-source-post_excerpt mb-3">
                <p>{post.excerpt}</p>
            </div>
            <div className="vc_btn3-container">
            {/* <a data-toggle="modal" className="vc_general" title={post.title} href={`#id${post.id}`}>Download</a>*/}
            { post.has_disclaimer ? post.file_url && <a data-toggle="modal" className="vc_general" title={post.title} href={`#id${post.id}`}>Download</a> : post.file_url && <a className="vc_general" title={post.title} href={post.file_url} download>Download</a>  }
            </div>
            {/* subscriber!=="0" && <Modal id={`id${post.id}`} file_url={post.file_url} disclaimer={post.has_disclaimer ? disclaimer : ''}/>*/}
            { post.has_disclaimer && <Modal id={`id${post.id}`} file_url={post.file_url} disclaimer={disclaimer}/>}

        </div>
    )
}

export default Cards